import { render, staticRenderFns } from "./ListarPlanMedico.vue?vue&type=template&id=575f4752&"
import script from "./ListarPlanMedico.vue?vue&type=script&lang=js&"
export * from "./ListarPlanMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports